var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20923_108958)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6719 24C19.2993 24 24.6719 18.6274 24.6719 12C24.6719 5.37258 19.2993 0 12.6719 0C6.04446 0 0.671875 5.37258 0.671875 12C0.671875 18.6274 6.04446 24 12.6719 24Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.1522 4.69434C2.20959 5.92073 1.49882 7.33424 1.08496 8.86982H7.32768L3.1522 4.69434Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2582 8.86977C23.8444 7.33424 23.1336 5.92073 22.191 4.69434L18.0156 8.86977H24.2582Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.08496 15.1299C1.49887 16.6654 2.20963 18.0789 3.1522 19.3053L7.32754 15.1299H1.08496Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9772 2.48037C18.7508 1.53776 17.3373 0.826992 15.8018 0.413086V6.65576L19.9772 2.48037Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.36621 21.5191C6.5926 22.4617 8.00612 23.1725 9.54165 23.5864V17.3438L5.36621 21.5191Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5416 0.413086C8.00607 0.826992 6.59255 1.53776 5.36621 2.48032L9.5416 6.65571V0.413086Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8018 23.5864C17.3373 23.1725 18.7508 22.4617 19.9771 21.5191L15.8018 17.3438V23.5864Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0156 15.1299L22.191 19.3053C23.1336 18.079 23.8444 16.6654 24.2582 15.1299H18.0156Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5703 10.4348H14.2372H14.2371V0.101578C13.7247 0.034875 13.2024 0 12.6719 0C12.1413 0 11.619 0.034875 11.1067 0.101578V10.4347V10.4347H0.773453C0.70675 10.9471 0.671875 11.4695 0.671875 12C0.671875 12.5306 0.70675 13.0529 0.773453 13.5652H11.1066H11.1066V23.8984C11.619 23.9651 12.1413 24 12.6719 24C13.2024 24 13.7247 23.9652 14.2371 23.8984V13.5653V13.5653H24.5703C24.637 13.0529 24.6719 12.5306 24.6719 12C24.6719 11.4695 24.637 10.9471 24.5703 10.4348Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8027 15.1309L21.1575 20.4857C21.4038 20.2395 21.6388 19.9821 21.8629 19.7153L17.2785 15.1309H15.8027V15.1309Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.54138 15.1309H9.54129L4.18652 20.4856C4.43271 20.7319 4.6901 20.9668 4.95691 21.191L9.54138 16.6064V15.1309Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.54163 8.8696V8.86951L4.18682 3.51465C3.94054 3.76084 3.7056 4.01823 3.48145 4.28504L8.06596 8.86955H9.54163V8.8696Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8027 8.8698L21.1576 3.5149C20.9114 3.26862 20.654 3.03368 20.3872 2.80957L15.8027 7.39409V8.8698Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20923_108958"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.671875)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUk);
export default __webpack_public_path__ + "static/media/uk.0a1f72b387cf0000cab617cab2238033.svg";
export { ForwardRef as ReactComponent };